import AvgOfFacingsByRetailerChart from "./AvgOfFacingsByRetailerChart";
export default AvgOfFacingsByRetailerChart;
